import { browser } from '$app/environment';

type balanceInput = ({ eth, usdc }?: { eth: string; usdc: string }) => { eth: number; usdc: number };

export const formatBalance: balanceInput = ({ eth, usdc } = { eth: '0', usdc: '0' }) => {
  if (browser) {
    const ethToNumber = Number(eth);
    const ethFormatted = Number(Number(ethToNumber).toFixed(4));
    const usdcFormatted = Number(Number(usdc).toFixed(4));

    return { usdc: usdcFormatted, eth: ethFormatted };
  }

  return { usdc: 0, eth: 0 };
};
